import React, { ComponentPropsWithRef } from 'react'
import { Button } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

import { useMobile } from '../hooks/useMobile'

export type YesNoModalProps = {
    open: boolean
    onClose?: () => void
    title?: string
    body?: string
    yesCta?: string
    onYes?: () => void  
    noCta?: string
    onNo?: () => void
}
type Props = ComponentPropsWithRef<'div'> & YesNoModalProps;
export const YesNoModal = (p: Props) => {
    const { className, onClose, open, title, body, yesCta, onYes, noCta, onNo, color, style, key, ...rest } = p
    const isMobile = useMobile()

    return (
        <Dialog
            ref={(ref) => { if (ref) ref.focus(); }}
            fullWidth
            maxWidth="sm"
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            PaperProps={{
                sx: {
                    maxHeight: '80vh',
                },
            }}
        >
            <DialogTitle
                sx={{
                    m: 0,
                    p: 2,
                    paddingRight: 6,
                    textAlign: 'center',
                    fontWeight: 'bold',
                    fontSize: isMobile ? '1.2rem' : '1.5rem',
                }}
                id="customized-dialog-title"
            >
                {title}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent
                dividers
                className="p-8"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    fontSize: isMobile ? '0.9rem' : '1.1rem',
                    overflowY: 'auto',
                }}
            >
                <p>{body}</p>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'space-between', p: 2 }}>
                {onNo  ? <Button
                    variant="outlined"
                    onClick={() => {
                        onNo();
                        onClose?.();
                    }}
                >
                    {noCta}
                </Button> : <div />}
                <Button
                    variant="contained"
                    autoFocus
                    onClick={() => {
                        onYes?.();
                        onClose?.();
                    }}
                >
                    {yesCta}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
